// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2cGdw","range":"MonthRangeSwitch_range__3A8sA","disabled":"MonthRangeSwitch_disabled__12EFV"};